import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

// Redux stuff
import { connect } from "react-redux";
import { getSheets, getComposers } from "../../Redux/Actions/dataActions";

// Sidebar
import SideBar from "../Sidebar/SideBar";

// CSS
import "./HomePage.css";

// Components
import Sheets from "../Sheets/Sheets";
import Composers from "../Composers/Composers";

class HomePage extends Component {

  componentDidMount = () => {
    // Change Page Title
    document.title = `SheetAble - Home`;

    if (this.props.sheets === undefined || this.props.sheets.length === 0) {
      this.props.getSheets();
    }

    if (
      this.props.composers === undefined ||
      this.props.composers.length === 0
    ) {
      this.props.getComposers();
    }
  };

  render() {
    const { t } = this.props; 
    const loadingJSX = <h1>loading</h1>;

    // ⭐ DUPLEX-KILLER MIT GROSS-/KLEINSCHREIBUNGS-ABSICHERUNG:
    // Filtert doppelte IDs (wie 'Yellow') synchron im Render-Frame aus, ohne echte Daten zu blockieren!
    const rawSheets = this.props.sheets || [];
    const seenSheetKeys = new Set();
    const uniqueSheets = rawSheets.filter(sheet => {
      if (!sheet) return false;
      // Nutzen id, ID oder den Sheet-Namen als eindeutigen Identifikator
      const key = sheet.id || sheet.ID || sheet.sheet_name;
      if (!key) return true; // Falls gar kein Key da ist, Song zur Sicherheit behalten
      if (seenSheetKeys.has(key)) return false; // Klon aussortieren
      seenSheetKeys.add(key);
      return true;
    });

    const rawComposers = this.props.composers || [];
    const seenComposerKeys = new Set();
    const uniqueComposers = rawComposers.filter(composer => {
      if (!composer) return false;
      const key = composer.id || composer.ID || composer.name;
      if (!key) return true;
      if (seenComposerKeys.has(key)) return false;
      seenComposerKeys.add(key);
      return true;
    });

    return (
      <Fragment>
        <SideBar history={this.props.history} />
        {this.props.loading ? (
          loadingJSX
        ) : (
          <div className="home_content">
            <div className="home-page-wrapper">
              <div className="space" />
              <div className="overflow-scroll">
                <span className="text">{t("PageHomePage.new_sheets")}</span>
                <hr className="seperator"></hr>
                <Sheets sheets={uniqueSheets} />
              </div>
              <div className="overflow-scroll">
                <span className="text">{t("PageHomePage.new_composer")}</span>
                <hr className="seperator"></hr>
                <Composers composers={uniqueComposers} />
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

HomePage.propTypes = {
  getSheets: PropTypes.func.isRequired,
  getComposers: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  sheets: state.data.sheets,
  composers: state.data.composers,
  loading: state.data.loading,
});

const mapActionsToProps = {
  getSheets,
  getComposers,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation()(HomePage));

